import React from 'react';
import { Button, Container } from "react-bootstrap";

const MIDAButton = () => {
  return (
    <Container
      as="section" 
      fluid 
      className="d-flex justify-content-center align-items-center py-5"
      style={{ backgroundColor: 'var(--tu-primary-yellow)' }}
    >
      <Button 
        href="https://transparent.utah.gov/mida/"
        target="_blank"
        rel="noopener noreferrer"
        size="lg" 
        variant="dark" 
        aria-label="Highest Paid Employees"
      >
        MIDA Public Timeline Dashboard
      </Button>
    </Container>
  );
};

export default MIDAButton;